import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@node_modules/@ngx-translate/core';
import { NgxPaginationModule } from '@node_modules/ngx-pagination';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { OmniDynamicPaginationComponent } from './omni-dynamic-pagination.component';
@NgModule({
  declarations: [OmniDynamicPaginationComponent],
  imports: [CommonModule, TranslateModule, NgxPaginationModule, MatFormFieldModule, MatSelectModule],
  exports: [OmniDynamicPaginationComponent, NgxPaginationModule],
})
export class OmniDynamicPaginationModule {}
